// extracted by mini-css-extract-plugin
module.exports = {"footer":"ProductsAssigner_footer__gjsKm"};